/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.875 0a.75.75 0 0 0 0 1.5h.375v1.5264c-2.3396.165-4.4675 1.0967-6.1343 2.5452a.754.754 0 0 0-.0854-.102l-1.5-1.5a.75.75 0 0 0-1.0606 1.0607l1.5 1.5a.754.754 0 0 0 .1019.0854C2.4697 8.459 1.5 10.8662 1.5 13.5 1.5 19.299 6.201 24 12 24s10.5-4.701 10.5-10.5c0-2.6338-.9697-5.041-2.5716-6.8843a.7462.7462 0 0 0 .1019-.0854l1.5-1.5a.75.75 0 0 0-1.0606-1.0606l-1.5 1.5a.7519.7519 0 0 0-.0854.1019C17.2175 4.123 15.0896 3.1915 12.75 3.0264V1.5h.375a.75.75 0 0 0 0-1.5h-2.25ZM3 13.5c0-4.9706 4.0294-9 9-9s9 4.0294 9 9-4.0294 9-9 9-9-4.0294-9-9Zm14.0303-3.9697a.75.75 0 0 0-1.0606-1.0606l-4.5 4.5a.75.75 0 0 0 0 1.0606.75.75 0 0 0 1.0606 0l4.5-4.5Z"
    clipRule="evenodd"
  />,
  'Stopwatch'
);
